export default "__VITE_ASSET__BEi2Es4S__"